import {Box} from "@mui/material";
import React from "react";

interface SpacerProps {}

export const Spacer = (props: SpacerProps) =>
    <Box sx={{height: "1rem"}} />
